import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

/**
 * Composant wrapper qui anime ses enfants quand ils entrent dans le viewport
 * Animations disponibles: 'fade-up', 'fade-in', 'scale-in', 'slide-left', 'slide-right'
 */
export const AnimateOnScroll = ({ 
  children, 
  animation = 'fade-up', 
  delay = 0, 
  className = '',
  threshold = 0.1
}) => {
  const [ref, isVisible] = useScrollAnimation({ threshold });

  const animations = {
    'fade-up': {
      initial: 'opacity-0 translate-y-8',
      visible: 'opacity-100 translate-y-0'
    },
    'fade-in': {
      initial: 'opacity-0',
      visible: 'opacity-100'
    },
    'scale-in': {
      initial: 'opacity-0 scale-95',
      visible: 'opacity-100 scale-100'
    },
    'slide-left': {
      initial: 'opacity-0 -translate-x-8',
      visible: 'opacity-100 translate-x-0'
    },
    'slide-right': {
      initial: 'opacity-0 translate-x-8',
      visible: 'opacity-100 translate-x-0'
    }
  };

  const anim = animations[animation] || animations['fade-up'];

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${isVisible ? anim.visible : anim.initial} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};
